
import React from "react";
import { motion } from "framer-motion";
import SectionHeading from "@/components/SectionHeading";

interface SectionHeaderProps {
  preTitle?: string;
  title: string;
  description?: string;
  centered?: boolean;
  showPreTitle?: boolean;
  showStepPrefix?: boolean; // Add new prop
  className?: string;
}

const SectionHeader = ({
  preTitle,
  title,
  description,
  centered = true,
  showPreTitle = false, // Default set to false, won't show preTitle
  showStepPrefix = false, // Default set to false, won't show Step prefix
  className,
}: SectionHeaderProps) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }} 
      whileInView={{ opacity: 1, y: 0 }} 
      transition={{ duration: 0.5 }} 
      viewport={{ once: true }} 
      className={`text-center mb-12 md:mb-16 ${className || ''}`}
    >
      <SectionHeading
        preTitle={preTitle}
        title={title}
        description={description}
        centered={centered}
        showPreTitle={showPreTitle}
        showStepPrefix={showStepPrefix}
        className="max-w-2xl mx-auto"
      />
    </motion.div>
  );
};

export default SectionHeader;
